module.exports = __webpack_public_path__ + "img/Super_Mobility_Logo_White.835768e1.svg";